module.exports = __webpack_public_path__ + "static/media/_ampersand.38c61ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_ampersand.jpg
// module id = 54
// module chunks = 0